export const CircleChevron = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
      <path
        d="M7.875 0C3.52617 0 0 3.52617 0 7.875C0 12.2238 3.52617 15.75 7.875 15.75C12.2238 15.75 15.75 12.2238 15.75 7.875C15.75 3.52617 12.2238 0 7.875 0ZM10.5943 7.98926L6.27012 11.1182C6.17695 11.185 6.04688 11.1182 6.04688 11.0039V10.1795C6.04688 10.0002 6.13301 9.82969 6.27891 9.72422L8.83477 7.875L6.27891 6.02578C6.13301 5.92031 6.04688 5.75156 6.04688 5.57051V4.74609C6.04688 4.63184 6.17695 4.56504 6.27012 4.63184L10.5943 7.76074C10.6717 7.81699 10.6717 7.93301 10.5943 7.98926Z"
        fill="currentColor"
      />
    </svg>
  );
};
